import { render, staticRenderFns } from "./customerRoom.vue?vue&type=template&id=f88d00a6&scoped=true&"
import script from "./customerRoom.vue?vue&type=script&lang=js&"
export * from "./customerRoom.vue?vue&type=script&lang=js&"
import style0 from "./customerRoom.vue?vue&type=style&index=0&id=f88d00a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88d00a6",
  null
  
)

export default component.exports